import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useUserStore } from 'src/_store/user.store'
import { CometChatUIKit, UIKitSettingsBuilder } from '@cometchat/chat-uikit-react'


export function CometChatProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUserStore((s) => ({ user: s.user }))

  // Single effect: initialize once, then (after init) log in the current user if needed
  useEffect(() => {
    if (typeof window === 'undefined') return
    const w = window as any
    const run = async () => {
      if (!user || !user.id) {
        console.log('Cometchat user not found')
        CometChatUIKit.logout();
        return
      }
      try {
        const cometUser: any = await CometChatUIKit.getLoggedinUser()
        if (cometUser && cometUser.uid === String(user.id)) return
        const token = localStorage.getItem('token')
        if (!token) return
        const resp = await axios.post<{ cometChatAuthToken: string }>(
          '/api/comet-chat/getToken',
          { email: user.email },
          { headers: { Authorization: `Bearer ${token}` } },
        )
        await CometChatUIKit.loginWithAuthToken(resp.data.cometChatAuthToken)
      } catch {
        console.log('Cometchat login failed')
      }
    }

    run()
  }, [user])

  return <>{children}</>
}
